import STORE_CONST from '../consts'
import accountApi from '../../api/account'

const state = {
	account: {},
	suchAccount: {},
}

const mutations = {
	// get current account info
	[STORE_CONST.ACCOUNT.CURRENT](state, account) {
		state.account = account
	},
	// update current account info
	[STORE_CONST.ACCOUNT.UPDATE](state, options) {
		state.account = Object.assign({}, state.account, options)
	},
	[STORE_CONST.ACCOUNT.GET_SUCH_ACCOUNT](state, suchAccount) {
		state.suchAccount = suchAccount
	},
}

const actions = {
	// login
	[STORE_CONST.ACCOUNT.LOGIN]({ commit }, data) {
		return new Promise((resolve, reject) => {
			accountApi.login(data).then(
				(res) => {
					commit(STORE_CONST.ACCOUNT.CURRENT, res.data)
					resolve(res.data)
				},
				(err) => {
					console.log('err', err)
					reject(err.data)
				}
			)
		})
	},
	[STORE_CONST.ACCOUNT.LOGIN_SSO]({ commit }, data) {
		return new Promise((resolve, reject) => {
			accountApi.loginSSO(data).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				}
			)
		})
	},
	// logout
	[STORE_CONST.ACCOUNT.LOGOUT]({ commit }) {
		return new Promise((resolve, reject) => {
			accountApi.logout().then((res) => {
				resolve(res.data)
				commit(STORE_CONST.ACCOUNT.CURRENT, {})
			})
		})
	},
	// reset password
	[STORE_CONST.ACCOUNT.RSET_PSWD]({ commit }, params) {
		return new Promise((resolve, reject) => {
			accountApi.resetPassword(params).then((res) => {
				resolve(res.data)
			})
		})
	},
	// compel change password
	[STORE_CONST.ACCOUNT.COMPEL_CHANGE_PSWD]({ commit }, params) {
		return new Promise((resolve, reject) => {
			accountApi.compelChangePassword(params).then((res) => {
				resolve(res.data)
			})
		})
	},
	// 获取当前用户信息
	[STORE_CONST.ACCOUNT.CURRENT]({ commit }) {
		return new Promise((resolve, reject) => {
			accountApi.getCurrent().then((res) => {
				commit(STORE_CONST.ACCOUNT.CURRENT, res.data)
				resolve(res.data)
			})
		})
	},
	// 上传用户头像
	[STORE_CONST.ACCOUNT.CAANGE_AVATAR]({ commit }, params) {
		return new Promise((resolve, reject) => {
			accountApi.changeAvatar(params).then((res) => {
				resolve(res.data)
			})
		})
	},
	// get such account info
	[STORE_CONST.ACCOUNT.GET_SUCH_ACCOUNT]({ commit }, id) {
		return new Promise((resolve, reject) => {
			accountApi.getSuchAccount(id).then((res) => {
				commit(STORE_CONST.ACCOUNT.GET_SUCH_ACCOUNT, res.data)
				resolve(res.data)
			})
		})
	},
	// update account info
	[STORE_CONST.ACCOUNT.UPDATE]({ commit }, params) {
		return new Promise((resolve, reject) => {
			accountApi.updateAccount(params).then((res) => {
				commit(STORE_CONST.ACCOUNT.UPDATE, res.data)
				resolve(res.data)
			})
		})
	},
	// get mfa secret
	[STORE_CONST.ACCOUNT.GET_MFA_SECRET]({ commit }) {
		return new Promise((resolve, reject) => {
			accountApi.getMfaSecret().then((res) => {
				// commit(STORE_CONST.ACCOUNT.UPDATE, res.data)
				resolve(res.data)
			})
		})
	},
	// post mfa code
	[STORE_CONST.ACCOUNT.POST_MFA_CODE]({ commit }, params) {
		return new Promise((resolve, reject) => {
			accountApi.postMfaCode(params).then((res) => {
				resolve(res.data)
			})
		})
	},
	// 登录验证mfa
	[STORE_CONST.ACCOUNT.VERIFY_MFA_CODE]({ commit }, params) {
		return new Promise((resolve, reject) => {
			accountApi.verifyMfa(params).then((res) => {
				resolve(res.data)
			})
		})
	},
	// get mobile code
	[STORE_CONST.ACCOUNT.CODE]({ commit }) {
		return new Promise((resolve, reject) => {
			accountApi.getCode().then((res) => {
				resolve(res.data)
			})
		})
	},
	// verift mobile code
	[STORE_CONST.ACCOUNT.VERIFY]({ commit }, params) {
		return new Promise((resolve, reject) => {
			accountApi.verifiCode(params).then((res) => {
				resolve(res.data)
			})
		})
	},
	// 忘记密码发送重置密码邮件
	[STORE_CONST.ACCOUNT.FORGRTPASSWORD]({ commit }, params) {
		return new Promise((resolve, reject) => {
			accountApi.forgotPassword(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err)
				}
			)
		})
	},
	// 登录增加显示是否显示验证码
	[STORE_CONST.ACCOUNT.SHOW_CAPTCHA]({ commit }, params) {
		return new Promise((resolve, reject) => {
			accountApi.showCaptcha(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err)
				}
			)
		})
	},
	// csos网站维护
	[STORE_CONST.ACCOUNT.NOTIFY_BANNER]({ commit }, params) {
		return new Promise((resolve, reject) => {
			accountApi.notifyBanner(params).then(
				(res) => {
					resolve(res.data.data)
				},
				(err) => {
					reject(err)
				}
			)
		})
	},
	// 校验是否开启SSO登录
	[STORE_CONST.ACCOUNT.CHECK_SSO]({ commit }, params) {
		return new Promise((resolve, reject) => {
			accountApi.checkSSO(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err)
				}
			)
		})
	},
}

const getters = {
	account: (state) => {
		return state.account
	},
	suchAccount: (state) => {
		return state.suchAccount
	},
}

export default {
	state,
	mutations,
	actions,
	getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/account.js